/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/NewsEntryComment', 'model/NewsEntryCommentPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/NewsEntryComment'), require('../model/NewsEntryCommentPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.NewsEntryCommentApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.NewsEntryComment, root.ForStractionServiceApi.NewsEntryCommentPaginationSlice);
  }
}(this, function(ApiClient, NewsEntryComment, NewsEntryCommentPaginationSlice) {
  'use strict';

  /**
   * NewsEntryComment service.
   * @module api/NewsEntryCommentApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new NewsEntryCommentApi. 
   * @alias module:api/NewsEntryCommentApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the newsEntryCommentAddPut operation.
     * @callback module:api/NewsEntryCommentApi~newsEntryCommentAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryComment} body 
     * @param {module:api/NewsEntryCommentApi~newsEntryCommentAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.newsEntryCommentAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryCommentAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntryCommentAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/NewsEntryComment/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntryCommentLoadAllGet operation.
     * @callback module:api/NewsEntryCommentApi~newsEntryCommentLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/NewsEntryComment>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/NewsEntryCommentApi~newsEntryCommentLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/NewsEntryComment>}
     */
    this.newsEntryCommentLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryCommentLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [NewsEntryComment];

      return this.apiClient.callApi(
        '/NewsEntryComment/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntryCommentLoadGet operation.
     * @callback module:api/NewsEntryCommentApi~newsEntryCommentLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NewsEntryComment} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/NewsEntryCommentApi~newsEntryCommentLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NewsEntryComment}
     */
    this.newsEntryCommentLoadGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryCommentLoadGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling newsEntryCommentLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NewsEntryComment;

      return this.apiClient.callApi(
        '/NewsEntryComment/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the newsEntryCommentSearchSlicePut operation.
     * @callback module:api/NewsEntryCommentApi~newsEntryCommentSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NewsEntryCommentPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/NewsEntryComment} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {module:api/NewsEntryCommentApi~newsEntryCommentSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NewsEntryCommentPaginationSlice}
     */
    this.newsEntryCommentSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling newsEntryCommentSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling newsEntryCommentSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'order': opts['order']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = NewsEntryCommentPaginationSlice;

      return this.apiClient.callApi(
        '/NewsEntryComment/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
